export interface ReviewPreference {
    id?: ID;
    destination: ReviewDestination;
    sendReviewEmailToAllTravelers: boolean;
    reviewTemplate?: string;
    reviewLink?: string;
    enableSmartReview?: boolean;
    smartReviewThreshold?: number;
}

export enum ReviewDestination {
    OFF = "off",
    XOLA = "xola",
    GOOGLE = "googlePlus",
    TRIPADVISOR = "tripAdvisor",
    YELP = "yelp",
    CUSTOM = "custom",
}

export const ReviewDestinationCopy = {
    [ReviewDestination.OFF]: "Off",
    [ReviewDestination.XOLA]: "Xola",
    [ReviewDestination.GOOGLE]: "Google",
    [ReviewDestination.TRIPADVISOR]: "TripAdvisor",
    [ReviewDestination.YELP]: "Yelp",
    [ReviewDestination.CUSTOM]: "Custom",
};
